import { Link, useLocation } from "@tanstack/react-router"
import { LucideIcon, Router, DollarSign, RefreshCw, Bot, Shield, Globe, Lock, Database, Zap, Workflow, Webhook, Settings, FileText, Building2, Server, Code, MessageSquare, Clock, Wrench, Eye, FileCheck, Network, AlertTriangle, CheckCircle, BarChart3, TrendingUp, TrendingDown, GraduationCap, Heart, Laptop, Rocket, Mail, Phone, MapPin, MousePointer, GitBranch, Puzzle, BrainCircuit, Users, Key, Activity, Link2, ArrowRight, ChevronDown, ArrowUpRight, ExternalLink } from "lucide-react"

const iconMap: Record<string, LucideIcon> = {
  Router,
  DollarSign,
  RefreshCw,
  Bot,
  Shield,
  Globe,
  Lock,
  Database,
  Zap,
  Workflow,
  Webhook,
  Settings,
  FileText,
  Building2,
  Server,
  Code,
  MessageSquare,
  Clock,
  Wrench,
  Eye,
  FileCheck,
  Network,
  AlertTriangle,
  CheckCircle,
  BarChart3,
  TrendingUp,
  TrendingDown,
  GraduationCap,
  Heart,
  Laptop,
  Rocket,
  Mail,
  Phone,
  MapPin,
  MousePointer,
  GitBranch,
  Puzzle,
  BrainCircuit,
  Users,
  Key,
  Activity,
  Link2,
}

interface SidebarItem {
  label: string
  href: string
  icon?: LucideIcon
  iconName?: string
}

interface SidebarSection {
  title?: string
  items: SidebarItem[]
}

interface ContentSidebarProps {
  sections: SidebarSection[]
  title?: string
}

export function ContentSidebar({ sections, title }: ContentSidebarProps) {
  const location = useLocation()
  const pathname = location.pathname

  return (
    <aside className="hidden lg:block w-64 flex-shrink-0">
      <nav className="sticky top-24 space-y-6">
        {title && (
          <h2 className="font-semibold text-lg">{title}</h2>
        )}
        {sections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            {section.title && (
              <h3 className="text-sm font-semibold text-muted-foreground mb-2">
                {section.title}
              </h3>
            )}
            <ul className="space-y-1">
              {section.items.map((item) => {
                const isActive = pathname === item.href
                const Icon = item.icon || (item.iconName ? iconMap[item.iconName] : undefined)
                return (
                  <li key={item.href}>
                    <Link
                      to={item.href}
                      className={`flex items-center gap-2 px-3 py-2 text-sm rounded-lg transition-colors ${
                        isActive
                          ? "bg-primary/10 text-primary font-medium"
                          : "text-muted-foreground hover:bg-muted hover:text-foreground"
                      }`}
                    >
                      {Icon && <Icon className="h-4 w-4" />}
                      {item.label}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  )
}
